import { __assign } from "tslib";
import hexToRgba from 'hex-rgba';
import spcColors from './spcColors';
import paletteDark from './paletteDark';
var black = spcColors.black,
    gray = spcColors.gray,
    white = spcColors.white,
    negative = spcColors.negative,
    accent = spcColors.accent,
    dark = spcColors.dark;

var limexDarkPalette = __assign(__assign({}, paletteDark), {
  background: {
    neutral: __assign(__assign({}, paletteDark.background.neutral), {
      primary: '#2F3237',
      secondary: '#252628',
      tertiary: '#272D35',
      popover: '#2F3237',
      primaryTransparent: 'rgba(47, 50, 55, 0.64)',
      dialogOverlay: 'rgba(18, 20, 23, 0.64)'
    }),
    semantic: {
      warning: '#473C24',
      accent: '#293B2F',
      positive: '#2C3633',
      negative: '#472E31',
      positiveGradient: 'linear-gradient(180deg, #202024 0%, #232A2B 50%, #253835 100%)',
      negativeGradient: 'linear-gradient(180deg, #241F23 0%, #30272A 50.99%, #472D30 100%)'
    },
    gradient: {
      primary: 'linear-gradient(180deg, #27272B 3.5%, rgba(39, 39, 43, 0) 96.51%)',
      secondary: 'linear-gradient(180deg, #2D2C30 3.5%, rgba(45, 44, 48, 0) 96.51%)',
      tertiary: 'linear-gradient(180deg, #1F1F21 3.5%, rgba(31, 31, 33, 0) 96.51%)'
    }
  },
  label: {
    accent: '#0BBC6F',
    accentHigh: '#0BA863',
    accentHighest: '#069858',
    primary: '#DBDDE1',
    secondary: '#848B9A',
    secondaryHigh: '#CDD2DB',
    tertiary: '#5B5F67',
    tertiaryHigh: '#929AAA',
    placeholder: '#5E646E',
    inactive: 'rgba(147, 151, 159, 0.4)',
    positive: '#45BA8D',
    negative: '#FF6164',
    warning: '#F7CC1E',
    inverse: '#0A0A0A',
    primaryActive: '#0BBC6F',
    secondaryActive: '#CDD2DB',
    tertiaryActive: '#929AAA',
    plaseholder: '#5E646E'
  },
  fill: __assign(__assign({}, paletteDark.fill), {
    primary: {
      highest: '#04B367',
      high: '#04CD76',
      mid: '#0DE386',
      low: '#05FA90',
      muted: '#464947',
      overlay32: 'rgba(10, 158, 86, 0.32)',
      overlay24: 'rgba(10, 158, 86, 0.24)',
      overlay16: 'rgba(10, 158, 86, 0.16)',
      overlay8: 'rgba(10, 158, 86, 0.08)'
    },
    secondary: {
      highest: '#DBDDE1',
      high: '#656D7B',
      mid: '#484D56',
      low: '#42464D',
      muted: '#45474A',
      overlay32: 'rgba(129, 140, 156, 0.32)',
      overlay24: 'rgba(129, 140, 156, 0.24)',
      overlay16: 'rgba(129, 140, 156, 0.16)',
      overlay8: 'rgba(129, 140, 156, 0.08)'
    }
  }),
  static: __assign(__assign({}, paletteDark.static), {
    secondary: '#4D566B'
  }),
  divider: __assign(__assign({}, paletteDark.divider), {
    primary: '#26282C',
    secondary: '#2A2C32',
    altPrimary: '#5A6272',
    altSecondary: '#3F4550'
  }),
  shadow: {
    button: '0px 1px 3px rgba(39, 47, 64, 0.18)',
    accent: '0px 3px 6px -2px rgba(21, 188, 88, 0.3), 0px 8px 12px rgba(21, 188, 88, 0.1), 0px 9px 16px rgba(56, 124, 255, 0.11)',
    popover: '0px 8px 16px rgba(95, 112, 149, 0.32), 0px 16px 40px rgba(95, 112, 149, 0.12)',
    dialog: '0px 12px 16px rgba(39, 47, 64, 0.1), 0px 24px 56px rgba(39, 47, 64, 0.38)',
    cardEasy: '0px 6px 16px rgba(82, 96, 122, 0.08)',
    cardHeavy: '0px 1px 4px rgba(95, 112, 149, 0.12), 0px 6px 16px rgba(95, 112, 149, 0.2)',
    headerWeb: '0px 1px 4px rgba(8, 55, 155, 0.04), 0px 6px 16px rgba(8, 55, 155, 0.04)'
  },
  base: {
    accent: accent['1'],
    error: negative['2'],
    disabled: black['3']
  },
  input: {
    main: {
      text: white['2'],
      background: hexToRgba(gray['2'], 8),
      backgroundDisabled: hexToRgba(gray['2'], 4),
      backgroundHover: hexToRgba(gray['2'], 16),
      backgroundError: hexToRgba(negative['2'], 8),
      border: black['3'],
      borderDisabled: hexToRgba(black['3'], 56),
      borderHover: gray['1'],
      borderError: negative['2']
    },
    label: gray['2'],
    message: gray['2']
  },
  menuItem: {
    backgroundHover: hexToRgba(accent['1'], 8),
    backgroundSelected: hexToRgba(accent['1'], 16)
  },
  button: {
    backgroundDisabled: hexToRgba(gray['2'], 6),
    border: hexToRgba(accent['1'], 32),
    borderDisabled: hexToRgba(white['1'], 8)
  },
  iconButton: {
    backgroundHover: hexToRgba(accent['1'], 8),
    backgroundFocused: hexToRgba(accent['1'], 16)
  },
  toggle: {
    background: black['2'],
    backgroundHover: hexToRgba(accent['1'], 8),
    backgroundActivated: hexToRgba(accent['1'], 16)
  },
  text: {
    primary: white['2'],
    secondary: gray['2']
  },
  paper: __assign(__assign({}, paletteDark.paper), {
    background: black['2']
  }),
  modal: {
    backdrop: hexToRgba(black['0'], 50)
  },
  dialog: {
    background: black['2']
  },
  dropDown: {
    background: dark['1']
  },
  dividerLegacy: {
    primary: dark['5'],
    secondary: dark['6']
  },
  switch: {
    icon: gray['3'],
    shadow: paletteDark.switch.shadow,
    track: gray['2']
  },
  calendar: {
    day: {
      backgroundHover: hexToRgba(black['1'], 56),
      backgroundCurrent: hexToRgba(accent['1'], 16)
    }
  },
  avatar: {
    backgroundPrimary: black['0'],
    backgroundSecondary: black['1']
  },
  snackbar: {
    text: black['1'],
    background: white['2']
  },
  tooltip: {
    background: hexToRgba(black['0'], 90),
    color: white['1']
  }
});

export default limexDarkPalette;